<template>
  <div class="addFile">
    <div class="addCourse">
      <div class="title">
        <strong>{{title}}</strong>
      </div>
      <div class="formContent">
        <mt-field v-model="ruleForm.roundsTitle" label="查房标题" placeholder="此项为必填项" type="text" @blur.native.capture="checkInputTitle"></mt-field>
        <!-- <mt-field v-model="ruleForm.applyNote" style="border-bottom:1px solid #ccc;" label="申请说明" placeholder="请输入" type="textarea"></mt-field> -->
        <div class="text-area" style="padding-bottom:10px;">
          <label for="bq">申请说明</label>
          <textarea id="bq" cols="35" rows="5" placeholder="此项为必填项" v-model="ruleForm.applyNote" @blur="checkInputNote"></textarea>
        </div>
        
        <div class="select-wrapper">
          <p style="padding-bottom:10px;">
            <label for="hzHospital">查房医院:</label>
            <select name="" id="hzHospital" class="hzHospital" placeholder="此项为必填项" v-model="ruleForm.roundsHospital">
              <option value="" disabled selected hidden>此项为必填项</option>
              <option v-for="(item, index) in roundsHospitalList" :value="item.id" :key="index">{{item.hospitalName}}</option>
            </select>
          </p>
          <p>
            <label for="hzHospital">查房医生:</label>
            <select name="" id="hzHospital" class="hzHospital" placeholder="此项为必填项" v-model="ruleForm.roundsDoctor">
              <option value="" disabled selected hidden>此项为必填项</option>
              <option :value="item.id" v-for="(item, index) in roundsDoctorList" :key="index">{{item.userName}}</option>
            </select>
          </p>
        </div>
        <!-- <mt-radio title="查房周期" :options="['单次', '每周', '每月']" v-model="ruleForm.roundsPeriod"></mt-radio> -->
        <div class="radioGroup">
          <span>查房周期</span>
          <div class="radio-inline">
            <input v-model="ruleForm.roundsPeriod" id="dc" type="radio" name="roundsPeriod" value="单次"/>
            <label for="dc">单次</label>
          </div>
          <div class="radio-inline">
            <input v-model="ruleForm.roundsPeriod" id="mz" type="radio" name="roundsPeriod" value="每周" />
            <label for="mz">每周</label>
          </div>
          <div class="radio-inline">
            <input v-model="ruleForm.roundsPeriod" id="my" type="radio" name="roundsPeriod" value="每月" />
            <label for="my">每月</label>
          </div>
        </div>
        <mt-field v-model="ruleForm.firstDate" style="ime-mode:disabled;margin-bottom:15px;display:inline-block;" label="首次日期" placeholder="此项为必填项" type="datetime" @focus.native.capture="openData"></mt-field>
        <mt-datetime-picker
          ref="picker"
          type="datetime"
          v-model="pickerValue"
          @confirm="handleConfirm"
          :startDate="startDate">
        </mt-datetime-picker>
        <div style="text-align:right;padding:2%;">
          <mt-button type="default" size="small" @click="cancel">取消</mt-button>
          &emsp;
          <mt-button type="primary" size="small" @click="handleSubmit">确认</mt-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { Indicator } from 'mint-ui'
import moment from 'moment'
import { MessageBox } from 'mint-ui'
export default {
  data() {
    return {
      hospitalId: localStorage.getItem('HospitalID'), //当前登录医院的id
      topHospitalId: '',  //上级医院的id
      title: '',
      pickerValue: '',  //开始时间
      startDate: '',
      ruleForm: {
        roundsTitle: '',
        applyNote: '',  //申请说明
        roundsHospital: '',
        roundsDoctor: '', 
        roundsPeriod: '单次',  //查房周期
        firstDate: []
      },
      roundsDoctorList: [],
      roundsHospitalList: [],
      id: this.$route.query.id,
      type: this.$route.query.type,
      notHospital: true,
    }
  },
  created() {
    this.getRoundHospitalList()
    // let curDate = new Date()
    // this.startDate = new Date(curDate.getTime() - 60*60*1000); //前一天
    this.startDate = new Date()
    if (this.type == 'edit') {
      this.title = '编辑申请'
      this.edit()
    } else {
      this.title = '查房申请'
    }
  },
  methods: {
    checkInputTitle() {
      if (this.ruleForm.roundsTitle == '') {
        Toast({
          message: '查房标题不能为空!',
          position: 'top',
          duration: 1500
        });
      }
    },
    checkInputNote() {
      if (this.ruleForm.applyNote == '') {
        Toast({
          message: '查房申请不能为空!',
          position: 'top',
          duration: 1500
        });
      }
    },
    checkInputHospital() {
      // alert(11)
    },
    // 添加查房申请
    addRound() {
      let formData = {
        roundsTitle: this.ruleForm.roundsTitle,
        applyNote: this.ruleForm.applyNote,
        roundsHospital: this.ruleForm.roundsHospital,
        roundsDoctor: this.ruleForm.roundsDoctor,
        firstDate: this.ruleForm.firstDate,
      }
      if (this.ruleForm.roundsPeriod == '单次') {
        formData.roundsPeriod = 1
      } else if (this.ruleForm.roundsPeriod == '每周') {
        formData.roundsPeriod = 2
      } else {
        formData.roundsPeriod = 3
      }

      if (this.notHospital) {
        for (let item in formData) {
          if (item == 'roundsHospital' || item == 'roundsDoctor') {
            continue
          } else {
            if (formData[item] == '') {
              Toast({
                message: '请把数据补充完整!',
                position: 'top',
                duration: 1500
              });
              return
            }
          }
        }
      } else {
        for (let item in formData) {
          if (formData[item] == '') {
            Toast({
              message: '请把数据补充完整!',
              position: 'top',
              duration: 1500
            });
            return
          }
        }
      }
      Indicator.open("加载中...")
      this.Axios.post("/api/Cooperative/AddCooperative", formData).then(res=>{
        if(res.data.status===103){
          Indicator.close()
          Toast({
            message: res.data.message,
            position: 'top',
            duration: 1500
          });
        }else if(res.data.status===100){
          Indicator.close()
          Toast({
            message: '添加成功!',
            position: 'top',
            duration: 1500
          });
          this.$router.push({
            name: 'WardRound'
          })
        }else{
          Indicator.close()
          Toast({
            message: '内部异常!',
            position: 'top',
            duration: 1500
          });
        }
      }).catch(error=>{
        Indicator.close()
        Toast({
          message: '网络错误,请联系管理员!',
          position: 'top',
          duration: 1500
        });
      })
    },
    // 获取查房信息 初始化编辑数据
    edit() {
      this.Axios.get("/api/Cooperative/GetCooperativeById?id="+this.id).then(res=>{
        const data = res.data
        if (data.status == 100) {
          if (data.data.roundsPeriod == 1) {
            data.data.roundsPeriod = '单次'
          } else if (data.data.roundsPeriod == 2) {
            data.data.roundsPeriod = '每周'
          } else {
            data.data.roundsPeriod = '每月'
          }
          data.data.firstDate = moment(data.data.firstDate).format('YYYY-MM-DD HH:mm')
          this.ruleForm = data.data
        }
        
      }).catch(error=>{
        Toast({
          message: '内部错误请联系管理员',
          position: 'top',
          duration: 1500
        });
      })
    },
    // 修改查房申请
    doEdit() {
      let formData = {}
      formData.roundsTitle = this.ruleForm.roundsTitle
      formData.applyNote = this.ruleForm.applyNote
      formData.roundsHospital = this.ruleForm.roundsHospital
      formData.roundsDoctor = this.ruleForm.roundsDoctor
      formData.firstDate = this.ruleForm.firstDate
      if (this.ruleForm.roundsPeriod == '单次') {
        formData.roundsPeriod = 1
      } else if (this.ruleForm.roundsPeriod == '每周') {
        formData.roundsPeriod = 2
      } else {
        formData.roundsPeriod = 3
      }
      if (this.notHospital) {
        for (let item in formData) {
          if (item == 'roundsHospital' || item == 'roundsDoctor') {
            continue
          } else {
            if (formData[item] == '') {
              Toast({
                message: '请把数据补充完整!',
                position: 'top',
                duration: 1500
              });
              return
            }
          }
        }
      } else {
        for (let item in formData) {
          if (formData[item] == '') {
            Toast({
              message: '请把数据补充完整!',
              position: 'top',
              duration: 1500
            });
            return
          }
        }
      }
      Indicator.open("加载中...")
      this.Axios.put("/api/Cooperative/UpdateCooperativeById?id=" + this.ruleForm.id, formData).then(res => {
        const data = res.data
        if (data.status == 100) {
          Indicator.close()
          Toast({
            message: '修改成功!',
            position: 'top',
            duration: 1500
          });
          this.$router.push({
            name: 'WardRound'
          })
        } else {
          Indicator.close()
          Toast({
            message: '修改失败!',
            position: 'top',
            duration: 1500
          });
        }
      })
    },
    openData() {
      this.$refs.picker.open()
      document.activeElement.blur()
    },
    handleConfirm() {
      this.ruleForm.firstDate = this.pickerValue
      this.ruleForm.firstDate = moment(this.pickerValue).format('YYYY-MM-DD HH:mm')
    },
    // 获取查房医院
    getRoundHospitalList() {
      this.Axios.get("/api/Hospital/GetSuperiorHospital?hospitalID=" + this.hospitalId).then(res=>{
        if(res.data.status===100){
          this.roundsHospitalList = res.data.data
          this.topHospitalId = res.data.data[0].id
          this.getRoundDoctorList(this.topHospitalId)
          this.notHospital = false
        } else if (res.data.status == 101) {
          Toast({
            message: '当前登录医院没有上级医院!',
            position: 'top',
            duration: 1500
          });
          this.notHospital = true
        }
      }).catch(error=>{
        Toast({
          message: '网络错误请联系管理员!',
          position: 'top',
          duration: 1500
        });
      })
    },
    // 获取查房医生
    getRoundDoctorList(topHospitalId) {
      this.Axios.get('/api/Hospital/GetDoctorByHId?hospitalId=' + topHospitalId).then(res => {
        if(res.data.status===100){
          this.roundsDoctorList = res.data.data
          // this.ruleForm.roundDoctor = res.data.data[0].id
        } else {
          Toast({
            message: '当前查房医院下没有医生!',
            position: 'top',
            duration: 1500
          });
        }
      }).catch(error=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },
    handleSubmit() {
      if (this.type == 'add') {
        this.addRound()
      } else {
        this.doEdit()
      }
    },    
    cancel() {
      this.$router.push({
        name: 'WardRound'
      })
    }
  }
}
</script>

<style lang="less">
.addFile {
  height: 99%;
  background: white;
  // border: 1px solid rebeccapurple;
  overflow: auto;
  // border: 1px solid rebeccapurple;
  .addCourse {
    height: 100%;
    // border: 1px solid rebeccapurple;
    .title {
      font-size: 14px;
      height: 3%;
      padding: 2% 2%;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      background: #f5f5f9;
    }
    .formContent {
      .radioGroup {
        height: 48px;
        line-height: 48px;
        padding: 0 10px;
        // border-top: 1px dashed #eeeeee;
        // border-bottom: 1px dashed #eee;
        span {
          width: 105px;
          display: block;
          float: left;
        }
        .radio-inline {
          float: left;
          margin-right: 10px;
          input[type="radio"] + label::before {
            content: "\a0";
            display: inline-block;
            vertical-align: middle;
            width: 10px;
            height: 10px;
            margin-right: 5px;
            border-radius: 50%;
            text-indent: .15em;
            margin-bottom: 4px;
            border: 1px solid #CCCCCC;
            padding: 2px;
          }
          input[type="radio"] {
            position: absolute;
            clip: rect(0, 0, 0, 0);
          }
          input[type="radio"]:checked + label::before {
            background-color: #4A90E2;
            background-clip: content-box;
            padding: 2px;
          }
        }
      }
      .text-area {
        padding-left: 10px;
        padding-right: 5px;
        margin-top: 16px;
        &::after {
          content: "";
          display: block;
          width: 0;
          height: 0;
          clear: both;
        }
        textarea {
          outline: none;
          width: 63% !important;
          border: 1px solid #ccc;
          float: left;
          border-radius: 4px;
        }
        label {
          display: block;
          width: 105px;
          // border: 1px solid rebeccapurple;
          float: left;
          top: 0;
        }
      }
      .select-wrapper {
        padding-left: 2%;
        .hzHospital{
          background: rgba(0,0,0,0);
          width: 55%;
          height: 32px;
          font-family: "微软雅黑";
          font-size: 14px !important;
          color: #aaa !important;
          border: 1px #ccc solid;
          border-radius: 5px;
          // margin-left: 2%;
          outline: none;
          &:focus{
            border: 1px #ddd solid;
            box-shadow: 0 0 15px 1px #DDDDDD;
          }
          option{
            color: black !important;
            background: white;
            line-height: 20px;
            // &:hover{
            //   background: #EBCCD1;
            // }
          }
        }
        .hys {
          display: inline-block;
          margin-right: 4%;
        }
      }
      .userGroup {
        padding-left: 3%;
        span {
          display: inline-block;
          margin-right: 3%;
        }
      }
    }
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder, select#hzHospital {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-moz-placeholder, textarea::-moz-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-ms-input-placeholder, textarea::-ms-input-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
}
</style>
